import React from "react";

import { Grid } from "@mui/material";

import Button from "components/Button/Button";

import "./toggleSwitch.scss";

function ToggleSwitch({ setCurrentTab = () => {}, currentTab = "", tabs = [] }) {
  return (
    <Grid className="switchertab-wrapper">
      {tabs?.map(({ title }) => (
        <Button
          key={title}
          className={`switchertab-button ${title === currentTab ? "primary" : "ghost"}`}
          type="button"
          id={`tab-${title}`}
          onClick={() => {
            setCurrentTab(title);
          }}
        >
          <div className="para-body-m-medium">{title}</div>
        </Button>
      ))}
    </Grid>
  );
}

export default ToggleSwitch;
